export const businessRegistrationCertificateUrl = {
  root: () => `/business_registration_certificate`,
};
